// extracted by mini-css-extract-plugin
module.exports = {"typicalWrapper":"styles_typicalWrapper__fCCAH","blink":"styles_blink__GJqNm"};